// REUSABLE FUNCTIONS
// ------------------

export function formatNumberWithThousandSeparator(number) {
  if (typeof number === 'number') {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }
  return number;
}
